import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getAuthDataUser } from 'selectors/auth';

export const useHubSpot = () => {
  const userData = useSelector(getAuthDataUser);
  const [isIdentified, setIsIdentified] = useState(false);
  const { pathname } = useLocation();

  // eslint-disable-next-line no-multi-assign
  const hsq = (window._hsq = window._hsq || []);

  useEffect(() => {
    if (!userData || isIdentified) {
      return;
    }
    const { email } = userData;

    hsq.push([
      'identify',
      {
        email,
      },
    ]);
    hsq.push(['trackPageView']);
    setIsIdentified(true);

    setTimeout(() => {
      if (window.HubSpotConversations && window.HubSpotConversations.widget) {
        window.HubSpotConversations.widget.refresh();
      } else {
        // eslint-disable-next-line no-console
        console.warn('HubSpot widget  not loaded');
      }
    }, 1000);
  }, [userData, isIdentified, hsq]);

  useEffect(() => {
    hsq.push(['setPath', pathname]);
    hsq.push(['trackPageView']);
  }, [pathname, hsq]);
};
